import { useState } from 'react';

import ConfirmationModals from './ConfirmationModals';
import SectionsAndSteps from './SectionsAndSteps';

export const TrainingMode = () => {
  const [showPlanCompleteModal, setShowPlanCompleteModal] = useState(false);

  return (
    <div className="mx-auto w-full p-4">
      <SectionsAndSteps
        showPlanCompleteModal={() => setShowPlanCompleteModal(true)}
      />
      <ConfirmationModals isOpen={showPlanCompleteModal} />
    </div>
  );
};
